export default "__VITE_ASSET__B_kiMw3f__";